import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Modal,
  Container,
  Title,
  ContainerTitle,
  ContainerItems,
  ContainerLeft,
  Tab,
  Content,
} from './styles';

const ModalWithColumns = (props) => {
  const {
    open,
    onClose,
    modalTitle,
    children,
    tabs,
    selectedTab,
    onSelectTab,
    showTab,
  } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      showTab={showTab}
    >
      <Container>
        <ContainerTitle spacetotabs={!!tabs} showTab={showTab}>
          <Title>{modalTitle}</Title>
        </ContainerTitle>

        <ContainerItems>
          {showTab && tabs && (
            <ContainerLeft>
              {_.map(tabs, (tab) => (
                <Tab
                  key={tab.key}
                  selected={selectedTab === tab.key}
                  onClick={() => onSelectTab(tab.key)}
                >
                  {tab.text}
                </Tab>
              ))}

            </ContainerLeft>
          )}
          <Content spacetotabs={showTab}>
            {children}
          </Content>
        </ContainerItems>
      </Container>
    </Modal>
  );
};

ModalWithColumns.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  modalTitle: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  tabs: PropTypes.objectOf(
    PropTypes.shape({
      text: PropTypes.string,
      key: PropTypes.string,
    }),
  ),
  selectedTab: PropTypes.string.isRequired,
  onSelectTab: PropTypes.func.isRequired,
  showTab: PropTypes.bool,
};

ModalWithColumns.defaultProps = {
  open: false,
  tabs: null,
  showTab: true,
};

export default ModalWithColumns;
